export enum AppRoutes {
    About = '/about',
    PatientsList = '/patients',
    PatientDetails = '/patients/{}',
    ObservationsHistory = '/patients/{}/observations',
    Adjudication = '/adjudication',
};

export enum ApiRoutes {
    PatientsAll = '/api/patients',
    Patient = '/api/patients/{}',
    ObservationsAllPerPatient = '/api/patients/{}/observations',
    RiskAssessmentsAllPerPatient = '/api/patients/{}/riskAssessments',
    Observations = '/api/observations',
    ObservationsChangeLabel ='/api/observations/{}/note',
};
